import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { SelectPaymentMethodPage } from 'src/app/shared/modals/select-payment-method/select-payment-method.page';
import { UpgradeStore } from 'src/app/shared/_services/store/upgradeStore.service';

@Component({
  selector: 'app-gold',
  templateUrl: './gold.page.html',
  styleUrls: ['./gold.page.scss'],
})
export class GoldPage implements OnInit {

  constructor(private modalController: ModalController, private upgradeStore: UpgradeStore) {}

  async changePaymentMethod() {
    const modal = await this.modalController.create({
      component: SelectPaymentMethodPage,
      backdropDismiss: true,
      showBackdrop: true,
      swipeToClose: true,
      // mode: 'ios',
      cssClass: 'bottom-modal create-dispute h-50'
    });
    return await modal.present();
  }

  ionViewDidEnter() {
    if (!this.upgradeStore.getIsBusinessRegistered()) {
      this.changePaymentMethod();
    }
  }

  ngOnInit(): void {
  }
}
